import {
  ColumnConfigurationRenderAs,
  IEntitySchemaDefinition,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { ListTable } from '../../components/ListTable/ListTable';

const Fieldset = ui.S9Fieldset.default;
const S9Row = ui.S9Row.default;
const S9Col = ui.S9Col.default;
const S9PageSection = ui.S9PageSection.default;

type Props = {
  schema: IEntitySchemaDefinition | undefined;
  applicationId: number;
};
const StaffBreakdownForm = ({ schema, applicationId }: Props) => {
  const fields = [
    { field: 'employee_count', colSize: 4 },
    { field: 'employee_count_1', colSize: 4 },
    { field: 'employee_count_2', colSize: 4 },
    { field: 'employee_count_3', colSize: 5 },

    { field: 'apprentice_count', colSize: 4 },
    { field: 'apprentice_count_1', colSize: 4 },
    { field: 'apprentice_count_2', colSize: 4 },
    { field: 'apprentice_count_3', colSize: 4 },
  ];

  const commonColumns = [
    {
      label: 'Female',
      field: 'total_female',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{total_female}}',
    },
    {
      label: 'Male',
      field: 'total_male',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{total_male}}',
    },
    {
      label: 'Other',
      field: 'total_other',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{total_other}}',
    },
  ];

  return (
    <>
      <S9PageSection title="Staff Counts" size="sm">
        {schema && (
          <>
            <Fieldset
              context={{ id: undefined }}
              schema={schema}
              formFields={fields}
            />
          </>
        )}
      </S9PageSection>
      <S9Row gutter={24}>
        <S9Col md={24}>
          <ListTable
            queryVars={{
              applicationId,
            }}
            columns={[
              {
                label: 'Age range',
                field: 'age_range',
                renderAs: ColumnConfigurationRenderAs.Text,
                value: '{{age_range}}',
              },
              ...commonColumns,
            ]}
            title="Staff age breakdown"
            queryName="getstaffagebreakdownlistbyapplication"
          />
        </S9Col>
      </S9Row>
      <S9Row gutter={24}>
        <S9Col md={12}>
          <ListTable
            queryVars={{
              applicationId,
            }}
            columns={[
              {
                label: 'Occupation',
                field: 'occupation_name',
                renderAs: ColumnConfigurationRenderAs.Text,
                value: '{{occupation_name}}',
              },
              ...commonColumns,
            ]}
            title="Apprentice occupation breakdown"
            queryName="getapprenticeoccupationbreakdownbyapplication"
          />
        </S9Col>
        <S9Col md={12}>
          <ListTable
            queryVars={{
              applicationId,
            }}
            columns={[
              {
                label: 'Age range',
                field: 'age_range',
                renderAs: ColumnConfigurationRenderAs.Text,
                value: '{{age_range}}',
              },
              ...commonColumns,
            ]}
            title="Apprentice age breakdown"
            queryName="getapprenticeagebreakdownbyapplication"
          />
        </S9Col>
      </S9Row>
    </>
  );
};

export default StaffBreakdownForm;
